import axios from 'axios'
import { TEST_URl } from '@/utils/constants.js'
const testUrl = localStorage.getItem(TEST_URl)

let baseUrl, walletBaseUrl, defaultBaseUrl
if (testUrl) {
  baseUrl = `${testUrl}/swaps`
  walletBaseUrl = `${testUrl}/wallet-address`
  defaultBaseUrl = testUrl
} else {
  baseUrl = `${process.env.VUE_APP_BASE_URL}/swaps`
  walletBaseUrl = `${process.env.VUE_APP_BASE_URL}/wallet-address`
  defaultBaseUrl = process.env.VUE_APP_BASE_URL
}
export async function getSwapPairsAssetsDetailsService () {
  const payload = {
    tenant: process.env.VUE_APP_TENANT_NAME
  }
  const res = await axios.get(`${baseUrl}/pairs?tenant=${payload.tenant}`, {})
  return res
}
export async function createBeneficiaryService (payload) {
  const res = await axios.post(`${walletBaseUrl}`, payload)
  return res
}
export async function getSavedBeneficiariesService (payload) {
  const hasSearch = payload?.network
    ? `&network=${payload.network}&asset=${payload.asset}`
    : ''
  const res = await axios.get(
    `${walletBaseUrl}?page=${payload.page}&size=${payload.size}&sort_by=created_at&sort_direction_desc=true${hasSearch}`
  )
  return res
}
export async function initiateSwapService (swapDetails) {
  const res = await axios.post(baseUrl, {
    ...swapDetails
  })
  return res
}
export async function deleteBeneficiaryService (payload) {
  const res = await axios.delete(
    `${walletBaseUrl}/${payload.walletID}?twoFaCode=${payload.twoFaCode}`
  )
  return res
}
export async function getSwappedPairDetailsByIdService (pairId) {
  const res = await axios.get(`${baseUrl}/${pairId}`, {})
  return res
}
export async function getSwappedTransactionsService (payload) {
  const res = await axios.get(
    `${baseUrl}?size=${payload.size}&from_asset=${payload.fromAsset}&to_asset=${payload.toAsset}&to_network=${payload.toNetwork}&from_network=${payload.fromNetwork}&page=${payload.page}&status=${payload.status}&from=${payload.from}&to=${payload.to}&sort_by=${payload.sort_by}&sort_direction_desc=${payload.sort_direction_desc}`,
    {}
  )
  return res
}
export async function processSwapApprovalService (payload) {
  const res = await axios.post(
    `${defaultBaseUrl}/transactions/requests/process`,
    payload
  )
  return res
}
